
<app-switcher></app-switcher>
<div class="page">
    <app-header></app-header>
    <app-sidebar appHoverEffectSidebar></app-sidebar>
    <!-- Start::app-content -->
    <div class="content main-index" (click)="clickOnBody()">
        <div class="main-content">
            <div #containerFluid class="container-fluid">

                <!-- Page Header -->
            <app-page-header></app-page-header>  
                <!-- Page Header Close -->
                <router-outlet></router-outlet>  
            </div>
        </div>   
    </div>   
    <app-footer></app-footer>
    <app-tab-to-top></app-tab-to-top>
</div> 
<div id="responsive-overlay" (click)="clearToggle()"></div>